var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 33,
    viewBox: "0 0 224 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.119 26.3751L65.908 20.6523H58.2024V17.4801H66.7855C69.363 17.4801 70.7221 16.007 70.7221 13.3445C70.7221 10.6821 69.249 9.37877 66.7855 9.37877H55.5689V26.3751H52V5.78076H66.7855C71.4878 5.78076 74.2631 8.69807 74.2631 13.2864C74.2631 16.6866 72.676 19.0931 70.0146 20.1135L76.2181 26.3729H71.119V26.3751Z",
    fill: "#003580"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.0861 26.3751V5.78076H96.4695V9.37765H81.6539V22.776H96.4964V26.374H78.085L78.0861 26.3751ZM84.2895 17.4243V14.393H95.7039V17.4243H84.2884H84.2895Z",
    fill: "#003580"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.973 26.3751C99.8962 26.3751 98.9316 25.7525 98.9316 24.5331C98.9316 23.9943 99.1876 23.4858 99.6694 23.0029L113.35 9.20999H99.1876V5.78076H117.202C118.25 5.78076 119.241 6.40446 119.241 7.6228C119.241 8.16043 118.986 8.67013 118.504 9.15187L104.824 22.947H119.156V26.374L100.973 26.3751Z",
    fill: "#003580"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.934 26.3749L143.997 11.9002L138.16 25.2986C137.765 26.176 137.199 26.6577 136.32 26.6577C135.47 26.6577 134.846 26.176 134.479 25.2986L128.673 11.9002L124.734 26.3749H121.194L126.491 7.00004C126.746 6.0086 127.313 5.52686 128.276 5.52686C129.04 5.52686 129.748 5.9516 130.089 6.7452L136.432 21.3038L142.778 6.7452C143.119 5.9516 143.741 5.52686 144.506 5.52686C145.384 5.52686 145.951 6.0086 146.234 7.00004L151.503 26.3749H147.934Z",
    fill: "#003580"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.352 26.3749L172.265 21.1908H162.521L164.22 18.2735H170.537L165.948 10.569L156.602 26.3738H152.494L164.333 6.66133C164.758 5.95269 165.297 5.5 166.09 5.5C166.883 5.5 167.393 5.95269 167.818 6.66133L179.685 26.376L175.352 26.3749Z",
    fill: "#003580"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.282 26.3751C182.206 26.3751 181.242 25.7525 181.242 24.5331C181.242 23.9943 181.498 23.4858 181.98 23.0029L195.661 9.20999H181.498V5.78076H199.513C200.56 5.78076 201.552 6.40446 201.552 7.6228C201.552 8.16043 201.297 8.67013 200.816 9.15187L187.134 22.947H201.467V26.374L183.282 26.3751Z",
    fill: "#003580"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204.608 26.3751V5.78076H222.992V9.37765H208.178V22.776H223.02V26.374L204.608 26.3751ZM210.812 17.4243V14.393H222.227V17.4243H210.813H210.812Z",
    fill: "#003580"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.5H4H32V4.5H4V32.5H0V4.5V0.5ZM7 11.5V32.5H11V11.5H28V32.5H32V11.5V7.5H28H11H7V11.5ZM18 14.5H14V32.5H18V14.5ZM21 14.5H25V32.5H21V14.5Z",
    fill: "#E54545"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo4);
export default __webpack_public_path__ + "static/media/logo4.e55f289633df4ae12b544bbed7e0f15d.svg";
export { ForwardRef as ReactComponent };